import React from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import { UiKit } from 'components';
import RetailerSelect from 'views/Login/components/RetailerSelect';
import { useForm } from 'utils/hooks';
import { FORM_SCHEMA } from './stubs';

export default function StepTwo({
  success = null,
  email = '',
  retailers = [],
  processing = false,
  onSubmit = () => {}
}) {
  const { data, errors, onChange } = useForm({
    dataSchema: FORM_SCHEMA,
    defaultData: {
      email,
      retailer_id: _get(retailers, '[0].options[0].value', null)
    }
  });

  const onFormSubmit = e => {
    e.preventDefault();
    onSubmit({ ...data, email: data.email.toLowerCase() });
  };

  return (
    <form onSubmit={onFormSubmit}>
      <UiKit.Grid templateColumns="1fr" gap="16">
        <UiKit.Input
          disabled
          type="email"
          name="email"
          value={data.email}
          onChange={value => onChange({ email: value })}
          placeholder="Email"
          error={!!errors.email}
        />
        <RetailerSelect
          list={retailers}
          value={data.retailer_id}
          onChange={value => onChange({ retailer_id: value })}
          error={errors.retailer_id}
          isDisabled={success !== null || processing}
        />
        <UiKit.Button
          type="submit"
          className="w-100"
          processing={processing}
          disabled={success !== null || !_isEmpty(errors)}
        >
          {success !== null ? 'Sent' : 'Get Reset Link'}
        </UiKit.Button>
      </UiKit.Grid>
    </form>
  );
}
